import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import SmartNavigator from './../generic/SmartNavigator'
import Features from '../configuration/features/Features'

const MainCalendars = () => {
  const { t_ } = useSmartTranslation()
  const componentsInfo = [
    {
      title: t_('Features'),
      component: <Features />
    }
  ]

  return (
    <div>
      <SmartNavigator componentsInfo={componentsInfo} sticky={false} />
    </div>
  )
}

export default MainCalendars
